import * as React from 'react';
import { wrapDisplayName } from '@cian/react-utils';

export interface IUnmountClosedProps {
  isOpen: boolean;
}

/**
 * HOC демонтирует компонент если isOpen false
 */
export const withUnmountClosed = <P extends IUnmountClosedProps>(Component: React.ComponentType<P>) => {
  return class UnmountClosed extends React.Component<P> {
    public static displayName = wrapDisplayName(Component, 'withUnmountClosed');

    public render() {
      return this.props.isOpen ? <Component {...(this.props as P)} /> : null;
    }
  };
};
